<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Insumos" icon="fas fa-boxes" btn_name="Insumo" @mtdBack="mtdBack"
          @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'"
          :button_new="true" :actions="true" :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
      <CRow>
        <CCol sm="12">
          <CInput label="Nombre" placeholder="Digite nombre del insumo" v-model="insumo.name" />
        </CCol>
        <CCol sm="12">
          <cSelectForm label="Unidad Base" placeholder="Seleccione unidad" :options="data_unit"
            :value.sync="insumo.unit_id" />
        </CCol>
        <CCol sm="12">
          <CInput label="Stock Mínimo" placeholder="Digite stock mínimo" type="number" v-model="insumo.stock_minimo" />
        </CCol>
        <CCol sm="12">
          <CInput label="Precio de Costo (S/)" placeholder="Digite precio de costo" type="number" step="0.01" v-model="insumo.price_cost" />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="insumo.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
            v-bind="labelIcon" />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Insumo'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "#", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:25%;" },
  { key: "unit_name", label: "Unidad Base", _style: "width:15%;" },
  { key: "stock_minimo", label: "Stock mínimo", _style: "width:15%;" },
  { key: "price_cost", label: "Precio Costo", _style: "width:15%;" },
  { key: "status", label: "Estado", _style: "width:10%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../shared/inputs/cSelect.vue";
import CSwitchVue from "../../shared/switch/CSwitch.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm,
  },
  data() {
    return {
      prefix: "insumos",
      fields,
      data: [],
      data_unit: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      insumo: {
        id: "",
        name: "",
        unit_id: "",
        stock_minimo: "",
        price_cost: "",
        state: 1,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },
  computed: {
    cpStatus: function () {
      if (this.insumo.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (
        this.insumo.name != "" &&
        this.insumo.stock_minimo != "" &&
        this.insumo.unit_id
      )
        return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "?per_page=100", // Pedimos muchos registros para obtener todos
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (!response.data || !response.data.data) {
            console.error('Error: Estructura de respuesta inválida:', response.data);
            Swal.fire({
              title: "Error al cargar datos",
              text: "No se pudieron cargar los insumos",
              icon: "error",
            });
            return;
          }
          
          // Manejar respuesta paginada: response.data.data.data contiene los items
          this.data = response.data.data.data || response.data.data;
          if (Array.isArray(this.data)) {
            this.data.forEach((element, index) => {
              element.status = element.state == 1 ? 'Activo' : 'Inactivo';
              element.Id = element.id; // Agregar Id con mayúscula para CDataTable
            });
            let index = 1;
            this.data.forEach((arr) => {
              arr.index = index;
              index++;
            });
          } else {
            console.error('Error: this.data no es un array:', this.data);
          }
        })
        .catch((errors) => {
          console.error('Error al cargar insumos:', errors);
        });
    },
    indexUnit: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/units/byUnit/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.data_unit.push({
              label: element.name,
              value: element.id,
              detail: element,
            });
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      (this.data_unit = []), this.indexUnit();
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Insumo")
        : (this.modal.title = "Editar Insumo");
      action == "store"
        ? (this.insumo = {
          id: "",
          name: "",
          unit_id: "",
          stock_minimo: "",
          price_cost: "",
          state: 1,
        })
        : (this.insumo = { ...this.insumo });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.insumo,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Insumo ya registrado",
              icon: "warning",
            });
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedInsumo = response.data.data[0];
              let index = this.data.findIndex(
                (insumo) => insumo.id === updatedInsumo.id
              );
              if (index !== -1) {
                this.$set(this.data, index, updatedInsumo);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
            };
            this.insumo = {
              id: "",
              name: "",
              unit_id: "",
              stock_minimo: "",
              state: 1,
            };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          console.error('Error al actualizar/crear insumo:', errors);
          Swal.fire({
            title: "Error al procesar la solicitud",
            text: errors.response?.data?.message || errors.message || "Error desconocido",
            icon: "error",
          });
        });
    },
    mtd_show: function (id) {
      
      if (!id) {
        console.error('Error: id is undefined in mtd_show');
        Swal.fire({
          title: "Error",
          text: "No se pudo identificar el insumo a editar",
          icon: "error",
        });
        return;
      }
      
      // Buscar el item completo en el array de datos
      const item = this.data.find(insumo => insumo.id == id);
      
      if (!item) {
        console.error('Error: No se encontró el insumo con id:', id);
        Swal.fire({
          title: "Error",
          text: "No se encontraron los datos del insumo",
          icon: "error",
        });
        return;
      }
      
      this.insumo = {
        id: item.id || '',
        name: item.name || '',
        unit_id: item.unit_id || '',
        stock_minimo: item.stock_minimo || '',
        state: item.state || 1,
      };
      this.mtd_open_modal(true, "update");
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.id,
        },
      })
        .then((response) => {
          this.modal_delete = {
            boo: false,
            item: [],
          };
          this.mtd_getdata();
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: "Error al eliminar",
            icon: "error",
          });
        });
    },
    changeSwitch: function (payload) {
      this.insumo.state = payload == true ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
